import { gql } from "gql";

export const REMOVE_DYNAMIC_PROCESS_MODEL = gql(/* GraphQL */ `
  mutation RemoveDynamicProcessModel($id: ID!) {
    removeDynamicProcessById(id: $id)
  }
`);
